import toastMessage from "../../toastMessage";
import { getStorage } from "../../storage";
import language from "../../../language";
import { defineRole } from "../../handleAccessRoles";
import { ROLE_RECEPTION } from "../../../constants/ROLES";
import api from "../../api";

const API_URL = process.env.REACT_APP_BBMS_BASE_API;

export const fetchReception = async (
  lng = "english",
  { page, limit, type, requestNo, donation, q, listType, shipmentNumber }
) => {
  try {
    const user = await getStorage();

    const canAccess = defineRole({
      roles: user.accessRole,
      menu: ROLE_RECEPTION,
      operation: "read",
    });

    if (!canAccess) return;

    const options = {
      method: "GET",
      url: `${API_URL}/reception`,
      params: {
        page: page,
        limit: limit,
        donation,
        requestNo,
        q,
        type: listType,
        shipmentNumber,
      },
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    const queryRes = await api(options);

    let { data, count, totalRecords } = queryRes.data;

    if (type === "dropdown") {
      return queryRes.data?.map((el) => {
        return {
          ...el,
          label: el.code + "-" + el?.center?.name,
          value: el._id,
        };
      });
    }

    return !page && !limit ? queryRes.data : { data, count, totalRecords };
  } catch (error) {
    toastMessage("error", error);
  }
};

export const deleteReception = async (lng = "english", params) => {
  try {
    const user = await getStorage();
    console.log(params);

    if (!params) return toastMessage("error", language[lng].error_delete_data);

    const options = {
      method: "DELETE",
      url: `${API_URL}/reception`,
      data: params,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    await api(options);

    toastMessage("success", language[lng].success_delete_data);
  } catch (error) {
    toastMessage("error", error);
  }
};
